<div>

  @if (!hideToolbar) {
    <kendo-toolbar [overflow]='true' [size]="'small'">
      <!-- <kendo-toolbar-button [icon]="'save'" [text]="'Save'" (click)="null"></kendo-toolbar-button> -->
      <kendo-toolbar-splitbutton [text]="this.typeLabels[this.type()]" [data]="types"></kendo-toolbar-splitbutton>
      <!-- <kendo-toolbar-button [togglable]="true" (click)="addMonitorFlow($event)" [text]="'Add New Flow to Monitor'"></kendo-toolbar-button> -->
      <grid-search-tool [search$]="this.search$"></grid-search-tool>
    </kendo-toolbar>
  }

  <kendo-grid class="flows-grid"
    [data]="this.view()"
    [scrollable]="'virtual'"
    [style.height]="'100%'"
    [rowHeight]="32"
    [resizable]="true"

    [pageSize]="100"
    [pageable]="true"
    [kendoGridSelectBy]="'flowName'"
    [size]="'small'"

    [sortable]="true"
    [filterable]="'menu'"
    (dataStateChange)="dataStateChange($event)"
    [filter]="this.state().filter"
    [sort]="this.state().sort"
    [skip]="this.state().skip"

    #grid>

    <kendo-grid-column field="shareOwners" title="Owner" [width]="30" [minResizableWidth]="30" [style]="{'min-width': '25px'}" class="cell">
      <ng-template kendoGridCellTemplate let-dataItem>
        <!-- <span [title]="dataItem.shareOwners | json">x</span> -->
        @if (dataItem.sharingType?.includes('Coauthor')) {
          <span class='ms-Icon ms-Icon--People' title='Shared Flow'
          [ngStyle]="{'color': dataItem.userType == 'Owner' ? 'green': 'black' }"></span>
        }
        @if (dataItem.sharingType?.includes('DelegatedAuth')) {
          <span class='ms-Icon ms-Icon--PeopleExternalShare' title='Resource Owner'
          [ngStyle]="{'color': dataItem.userType == 'Owner' ? 'dodgerblue': 'black' }"></span>
        }
        @if (dataItem.sharingType?.includes('CommonDataService')) {
          <i class="ms-Icon ms-Icon--CommonDataServiceCDS" title="Solution Aware"
          [ngStyle]="{'color': '#742873' }"></i>
        }
        <!-- <i class="ms-Icon ms-Icon--Contact" *ngIf="dataItem.owners.length == 1"></i>
        <i class="ms-Icon ms-Icon--People" *ngIf="dataItem.owners.length > 1"></i> -->
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="displayName" title="Display Name" [width]="160" class="cell">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span (click)="editFlow(dataItem)" style="display:inline-flex;align-items:center;gap:6px;text-decoration: underline;  cursor: pointer;">
          <img [src]="this.getTriggerIcon(dataItem)" style="width:18px; height:18px; vertical-align:middle; flex-shrink:0;" [title]="getTriggerLabel(dataItem)" />
          <span>{{dataItem.displayName}}</span>
        </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="ref_environment.displayName" title="Environment" [width]="80" [minResizableWidth]="80" class="cell" [style]="{'min-width': '50px'}">
    </kendo-grid-column>
    <!-- <kendo-grid-column field="triggerType" title="Trigger" [width]="50" [minResizableWidth]="50" [style]="{'min-width': '50px'}" class="cell" *ngIf="this.type()=='request'">
  </kendo-grid-column>
  <kendo-grid-column field="triggerKind" title="Kind" [width]="50" [minResizableWidth]="50" [style]="{'min-width': '50px'}" class="cell" *ngIf="this.type()=='request'">
  </kendo-grid-column> -->
  @if (this.type()=='request') {
    <kendo-grid-column field="triggerType" title="Trigger" [width]="60" [minResizableWidth]="60" [filterable]="false" [style]="{'min-width': '60px'}" class="cell">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ getTriggerLabel(dataItem) }}{{ dataItem.triggerKind ? '/' + dataItem.triggerKind : '' }}
      </ng-template>
    </kendo-grid-column>
  }
  @if (this.type()=='request') {
    <kendo-grid-column field="triggerUrl" title="Url" [width]="50" [minResizableWidth]="50" [style]="{'min-width': '50px'}" class="cell">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span [title]="dataItem.triggerUrl">{{ dataItem.triggerUrl }}</span>
      </ng-template>
    </kendo-grid-column>
  }
  <kendo-grid-column field="state" title="On/Off" [width]="30" [minResizableWidth]="30" [style]="{'min-width': '30px'}" class="cell">
    <!-- <ng-template kendoGridHeaderTemplate let-column>
    <i class="ms-Icon ms-Icon--PowerButton" style='font-weight:bold;' aria-hidden="true" title="{{column.title}}"></i>
  </ng-template> -->
  <ng-template kendoGridCellTemplate let-dataItem>
    @switch (dataItem.state) {
      @case ('Started') {
        <span class='cell cell-filter' style='color:green;'
          (click)='this.filterByFlowState(dataItem.state)' title='Started'>
          <i class="ms-Icon ms-Icon--PowerButton" style='font-weight:bold;' aria-hidden="true"></i>
        </span>
      }
      @case ('Stopped') {
        <span class='cell cell-filter' style='color:gray'
          (click)='this.filterByFlowState(dataItem.state)' title='Stopped'>
          <i class="ms-Icon ms-Icon--Blocked2" style='font-weight:bold;' aria-hidden="true"></i>
        </span>
      }
      @case ('Deleted') {
        <span class='cell cell-filter' style='color:red'
          (click)='this.filterByFlowState(dataItem.state)' title='Deleted'>
          <i class="ms-Icon ms-Icon--Blocked2" style='font-weight:bold;' aria-hidden="true"></i>
        </span>
      }
      @case ('Suspended') {
        <span class='cell cell-filter' style='color:red'
          (click)='this.filterByFlowState(dataItem.state)' [title]="('Suspended: ')+(dataItem.flowSuspensionReason)">
          <i class="ms-Icon ms-Icon--ShieldAlert" style='font-weight:bold;' aria-hidden="true"></i>
        </span>
      }
      @default {
        <span>{{dataItem.state}}</span>
      }
    }
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="lastModifiedTime" title="Last Modified" [width]="60" [minResizableWidth]="60" type="date" format="{0:y-MM-dd HH:mm}"
  filter="date" class="cell" [style]="{'min-width': '65px'}">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
    <!-- <i class="ms-Icon ms-Icon--DateTime" style='font-weight:normal;' aria-hidden="true" title="{{column.title}}"></i> -->
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <span title="{{dataItem.lastModifiedTime|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.lastModifiedTime|date:'y-MM-dd HH:mm'}}</span>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="periodRuns" title="Runs" [width]="35" [minResizableWidth]="35" type="number" filter="numeric" [filterable]="false" class="cell" [style]="{'min-width': '25px'}">
</kendo-grid-column>
<kendo-grid-column field="periodFailed" title="Errors" [width]="25" [minResizableWidth]="25" type="number" filter="numeric" [filterable]="false" [style]="{'min-width': '25px'}" class="cell">
</kendo-grid-column>
<kendo-grid-column field="periodSuccessed" title="Success" [width]="70" [minResizableWidth]="60" [filterable]="false" [style]="{'min-width': '60px'}" class="cell">
  <ng-template kendoGridCellTemplate let-dataItem>
    <span class="flows-status-pill"
      [class.is-warning]="getSuccessRateTone(dataItem) === 'warning'"
      [class.is-critical]="getSuccessRateTone(dataItem) === 'critical'">
      {{ getSuccessRateLabel(dataItem) }}
    </span>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="runLast" title="Last Ran" [width]="60" [minResizableWidth]="60" type="date" format="{0:y-MM-dd HH:mm}" filter="date" class="cell" [style]="{'min-width': '65px'}">
</kendo-grid-column>
<kendo-grid-column field="monitor" title="Rules" [width]="60" [minResizableWidth]="55" type="text" [filterable]="false" [style]="{'min-width': '55px'}" class="cell">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="Monitor / Fail alert / Missing alert">Rules</div>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <div style="display:inline-flex;align-items:center;gap:4px;cursor:pointer;" title="Edit rules" (click)="editFlow(dataItem)">
      <span [title]="dataItem.monitor ? 'Monitored: runs are being scanned.' : 'Not monitored'"
        style="color:#005595;display:inline-flex;width:16px;">
        @if (dataItem.monitor) {
          <i class="ms-Icon ms-Icon--RedEye" aria-hidden="true"></i>
        }
      </span>
      <!-- On Fail: MailError -->
      <span [title]="dataItem.rule_notify_onfail ? 'Fail alert → ' + (dataItem.computed?.emails||[]).join(', ') : 'No fail alert'"
        style="color:#cc4444;display:inline-flex;width:16px;">
        @if (dataItem.rule_notify_onfail) {
          <svg width="16" height="16" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.5 3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.25ZM17 14.5v-4.1c.36-.18.7-.4 1-.66v4.76a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 14.5v-8A2.5 2.5 0 0 1 4.5 4h4.7c-.08.32-.15.66-.18 1H4.5C3.67 5 3 5.67 3 6.5v.3l7 4.12 1.44-.85c.33.22.68.4 1.04.55l-2.23 1.31a.5.5 0 0 1-.42.04l-.08-.04L3 7.96v6.54c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5Z"/></svg>
        }
      </span>
      <!-- On Missing: MailAlert -->
      <span [title]="dataItem.rule_notify_onmissingdays ? 'Missing alert: no run in ' + dataItem.rule_notify_onmissingdays + ' days → ' + (dataItem.computed?.emails||[]).join(', ') : 'No missing alert'"
        style="color:#cc8800;display:inline-flex;width:16px;">
        @if (dataItem.rule_notify_onmissingdays) {
          <svg width="16" height="16" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 4a3 3 0 0 1 6 0v2l1.32 1.12a.5.5 0 0 1-.33.88H10.5a.5.5 0 0 1-.32-.88L11.5 6V4Zm3 6a1.5 1.5 0 0 1-1.42-1h2.83c-.2.58-.76 1-1.41 1Zm-10-5h6V4h-6A2.5 2.5 0 0 0 2 6.5v8A2.5 2.5 0 0 0 4.5 17h11a2.5 2.5 0 0 0 2.5-2.5V9h-1v5.5c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 14.5V7.96l6.75 3.97.08.04c.14.05.3.04.42-.04l2.62-1.54a2.5 2.5 0 0 1-.62-.8L10 10.93 3 6.8v-.3C3 5.67 3.67 5 4.5 5Z"/></svg>
        }
      </span>
    </div>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <span title="{{dataItem.runLast|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.runLast|date:'y-MM-dd HH:mm'}}</span>
  </ng-template>
</kendo-grid-column>
<!-- <kendo-grid-column class="clip cell" [width]="16" [minResizableWidth]="16" [headerStyle]="{ 'min-width': '16px', 'text-overflow': 'clip' }">
<ng-template kendoGridHeaderTemplate let-column>
  <kendo-grid-column-chooser></kendo-grid-column-chooser>
</ng-template>
</kendo-grid-column> -->

<ng-template kendoGridNoRecordsTemplate>
  @if (!this.loaded()) {
    <span class="inline-flex items-center gap-2 text-slate-500">
      <span class="k-icon k-i-loading"></span>
      <span>Loading flows…</span>
    </span>
  }
  @if (this.loaded()) {
    <p>There is no data to display.</p>
  }
</ng-template>
<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
  <kendo-pager-numeric-buttons [buttonCount]="buttonCount"></kendo-pager-numeric-buttons>
  <kendo-pager-next-buttons></kendo-pager-next-buttons>
  <kendo-pager-input></kendo-pager-input>
  <kendo-pager-info></kendo-pager-info>
  <kendo-pager-page-sizes [pageSizes]="[50,100,150]"></kendo-pager-page-sizes>
</ng-template>
</kendo-grid>
</div>
